import { render, staticRenderFns } from "./PageDonations.vue?vue&type=template&id=745f8bca&scoped=true&"
import script from "./PageDonations.vue?vue&type=script&lang=ts&"
export * from "./PageDonations.vue?vue&type=script&lang=ts&"
import style0 from "./PageDonations.vue?vue&type=style&index=0&id=745f8bca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745f8bca",
  null
  
)

export default component.exports